var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectGroup',{attrs:{"id":"status","displayName":"Status","options":_vm.statusOptions,"error":_vm.error},on:{"input":_vm.handleInput},model:{value:(_vm.statusSelected),callback:function ($$v) {_vm.statusSelected=$$v},expression:"statusSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }